<template lang="pug">
.facility-detail-modal
  b-modal(v-model="_modalShow" size="xl" title="施設情報詳細" no-close-on-backdrop no-close-on-esc static)
    .facility.register-body(v-if="facility")
      .d-flex.flex-row
        .facility-image.m-4(v-if="image")
          b-img.facility-image(:src="image" :alt="_facilityImageAlt" fluid)
        .facility-basic-info.m-4(v-if="facility")
          .facility-name.mt-2.mb-2
            span {{ facility.name }}
          .facility-type.mb-1(v-if="_facilityCategory")
             span {{ _facilityCategory }}
          .facility-address.mb-1
            span {{ facility.address }}
          .facility-tel.mb-1
            span {{ facility.tel }}
          .facility-url.mb-1
            a.link(:href="facility.url" target="_blank")
              span.link-text(style="margin:0;") {{ facility.url }}
      .d-flex.flex-column
        CareLebelLabel(:value="_facilityCareLevels")
        FormLabel(key-name="生活保護" :value="_acceptsWelfare")
        MedicalNursingsLabel(:value="_facilityMedicalNursings")
        FormLabel(key-name="受け入れ条件の補足事項" :value="_acceptanceConditions")

    template(#modal-footer="{ ok, cancel }")
      .buttons
        //- button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { CareLevels, FacilityCategory, FacilityGetModel, MedicalNursings } from "@/commons/services/Facilities";

import CareLebelLabel from "@/pc/components/base/CareLebelLabel.vue";
import FormLabel from "@/pc/components/forms/FormLabel.vue";
import MedicalNursingsLabel from "@/pc/components/base/MedicalNursingsLabel.vue";

/**
 * ### 施設詳細モーダル
 */
@Component({
  components: {
    CareLebelLabel,
    FormLabel,
    MedicalNursingsLabel
  }
})
export default class FacilityDetailModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** 施設情報 */
  @Prop()
  facility!: FacilityGetModel;
  /** 施設画像 */
  @Prop()
  image!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _facilityImageAlt(): string {
    return this.facility ? this.facility.name : "";
  }

  get _facilityCategory(): string | null {
    if (this.facility && this.facility.facilityDetailInfo && this.facility.facilityDetailInfo.facilityCategory) {
      switch (this.facility.facilityDetailInfo.facilityCategory) {
        case FacilityCategory.KAIGO_YUURYOU:
          return "介護付有料老人ホーム";
        case FacilityCategory.JYUUTAKU_YUURYOU:
          return "住宅型有料老人ホーム  ";
        case FacilityCategory.SERVICE_JYUUTAKU:
          return "サービス付き高齢者向け住宅";
        case FacilityCategory.CONDOMINIUMS:
          return "シニア向け分譲マンション";
        case FacilityCategory.GROUP_HOME:
          return "グループホーム";
        case FacilityCategory.CARE_HOUSE:
          return "ケアハウス";
        case FacilityCategory.TOKUYO:
          return "特別養護老人ホーム（特養）";
        case FacilityCategory.KAIGO_HOKEN:
          return "介護老人保健施設（老健）";
        case FacilityCategory.MEDICAL_CENTER:
          return "介護医療院";
        case FacilityCategory.OTHER:
          return "その他";
        default:
          return "";
      }
    }

    return null;
  }

  get _facilityCareLevels(): CareLevels | null {
    if (this.facility && this.facility.facilityDetailAccept && this.facility.facilityDetailAccept.careLevels) {
      return this.facility.facilityDetailAccept.careLevels;
    }
    return null;
  }

  get _acceptsWelfare(): string {
    if (this.facility && this.facility.facilityDetailAccept) {
      if (this.facility.facilityDetailAccept.acceptsWelfare == true) {
        return "受け入れ可";
      } else if (this.facility.facilityDetailAccept.acceptsWelfare == false) {
        return "受け入れ不可";
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  get _facilityMedicalNursings(): MedicalNursings | null {
    if (this.facility && this.facility.facilityDetailAccept && this.facility.facilityDetailAccept.medicalNursings) {
      return this.facility.facilityDetailAccept.medicalNursings;
    }
    return null;
  }

  get _acceptanceConditions(): string {
    if (this.facility && this.facility.facilityDetailAccept && this.facility.facilityDetailAccept.acceptanceConditions) {
      return this.facility.facilityDetailAccept.acceptanceConditions;
    } else {
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
.facility-detail-modal {
  ::v-deep {
    .facility {
      .facility-image {
        width: 435px;
        max-width: 435px;
        min-width: 435px;
      }

      .facility-basic-info {
        .facility-name {
          font-size: 20px;
          font-weight: bold;
        }
      }

      .cancel-btn {
        width: 120px;
      }
    }
  }
}
</style>
